<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.08225 9.94955L2.16506 4.53582C2.08236 4.4722 2.03571 4.37254 2.03571 4.26863V2.62946C2.03571 2.48738 2.19899 2.40892 2.30925 2.49586L9.49999 8.12377L16.6907 2.49586C16.7157 2.47629 16.7457 2.46414 16.7773 2.46081C16.8089 2.45748 16.8408 2.4631 16.8693 2.47704C16.8979 2.49098 16.9219 2.51266 16.9387 2.53961C16.9555 2.56657 16.9643 2.5977 16.9643 2.62946V4.26863C16.9643 4.37254 16.9155 4.4722 16.8349 4.53582L9.91986 9.94955C9.67175 10.1425 9.32823 10.1425 9.08225 9.94955ZM9.08225 16.396L2.16506 10.9822C2.08236 10.9186 2.03571 10.819 2.03571 10.7151V9.07589C2.03571 8.93381 2.19899 8.85535 2.30925 8.94229L9.49999 14.5702L16.6907 8.94229C16.7157 8.92271 16.7457 8.91056 16.7773 8.90724C16.8089 8.90391 16.8408 8.90953 16.8693 8.92347C16.8979 8.9374 16.9219 8.95909 16.9387 8.98604C16.9555 9.013 16.9643 9.04413 16.9643 9.07589V10.7151C16.9643 10.819 16.9155 10.9186 16.8349 10.9822L9.91986 16.396C9.67175 16.5889 9.32823 16.5889 9.08225 16.396Z"
      fill="#00B96B"
      fill-opacity="0.733333"
    />
  </svg>
</template>
